import React from 'react';
import PropTypes from "prop-types";

import styles from './lesson.css';
import bindAll from "lodash.bindall";

import up from '../../components/wrapped-gui/up.svg';
import down from '../../components/wrapped-gui/down.svg';
import left from '../../components/wrapped-gui/left.svg';
import right from '../../components/wrapped-gui/right.svg';

class KeyBoard extends React.PureComponent {

    constructor(props) {
        super(props);
        bindAll(this, [
            'keyClickStart',
            'keyClickEnd'
        ]);
    }

    componentDidMount() { }


    //虚拟键盘按键
    keyClickStart(event, letter, key) {
        this.props.vm.postIOData("keyboard", {
            keyCode: letter,
            key: key,
            isDown: true,
        });
        event.preventDefault();
    }

    keyClickEnd(event, letter, key) {
        this.props.vm.postIOData("keyboard", {
            keyCode: letter,
            key: key,
            isDown: false,
        });
        event.preventDefault();
    }


    render() {
        const { keyboardType } = this.props
        return (
            <React.Fragment>
                <div className={styles.keybordeFullScreen}>
                    {
                        keyboardType === 1 ? (
                            <div className={`${styles.keybordBox} ${styles.keybordPhone}`}>
                                <div className={styles.diamond}>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 38, 'ArrowUp')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 38, 'ArrowUp')}
                                    ><img src={up} /></span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 39, 'ArrowRight')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 39, 'ArrowRight')}
                                    ><img src={right} /></span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 40, 'ArrowDown')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 40, 'ArrowDown')}
                                    ><img src={down} /></span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 37, 'ArrowLeft')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 37, 'ArrowLeft')}
                                    ><img src={left} /></span>
                                </div>
                                <div className={styles.large}>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 32, ' ')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 32, ' ')}
                                    >空格</span>
                                </div>
                            </div>
                        ) : (null)
                    }
                    {
                        keyboardType === 2 ? (
                            <div className={`${styles.keybordBox} ${styles.keybordPhone}`}>
                                <div className={styles.diamond}>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 87, 'W')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 87, 'W')}
                                    >W</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 68, 'D')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 68, 'D')}
                                    >D</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 83, 'S')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 83, 'S')}
                                    >S</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 65, 'A')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 65, 'A')}
                                    >A</span>
                                </div>
                                <div className={styles.large}>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 32, ' ')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 32, ' ')}
                                    >空格</span>
                                </div>
                            </div>
                        ) : (null)
                    }
                    {
                        keyboardType === 3 ? (
                            <div className={`${styles.keybordBox} ${styles.keybordPhone}`}>
                                <div className={styles.diamond}>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 87, 'W')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 87, 'W')}
                                    >W</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 68, 'D')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 68, 'D')}
                                    >D</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 83, 'S')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 83, 'S')}
                                    >S</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 65, 'A')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 65, 'A')}
                                    >A</span>
                                </div>
                                <div className={styles.diamond}>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 38, 'ArrowUp')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 38, 'ArrowUp')}
                                    ><img src={up} /></span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 39, 'ArrowRight')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 39, 'ArrowRight')}
                                    ><img src={right} /></span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 40, 'ArrowDown')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 40, 'ArrowDown')}
                                    ><img src={down} /></span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 37, 'ArrowLeft')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 37, 'ArrowLeft')}
                                    ><img src={left} /></span>
                                </div>
                            </div>
                        ) : (null)
                    }
                    {
                        keyboardType === 4 ? (
                            <div className={`${styles.keybordBox} ${styles.keybordPhone}`}>
                                <div className={styles.jiugongge}>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 85, 'U')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 85, 'U')}
                                    >U</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 73, 'I')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 73, 'I')}
                                    >I</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 79, 'O')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 79, 'O')}
                                    >O</span>
                                </div>
                                <div className={styles.jiugongge}>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 72, 'H')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 72, 'H')}
                                    >H</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 74, 'J')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 74, 'J')}
                                    >J</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 75, 'K')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 75, 'K')}
                                    >K</span>
                                </div>
                                <div className={styles.jiugongge}>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 90, 'Z')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 90, 'Z')}
                                    >Z</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 88, 'X')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 88, 'X')}
                                    >X</span>
                                    <span
                                        onTouchStart={(e) => this.keyClickStart(e, 67, 'C')}
                                        onTouchEnd={(e) => this.keyClickEnd(e, 67, 'C')}
                                    >C</span>
                                </div>
                            </div>
                        ) : (null)
                    }
                </div>
            </React.Fragment>
        );
    }
}

export default KeyBoard;
